import Swiper, { Scrollbar } from "swiper";

export default () => ({
  swiper: null,
  isMobile: null,
  wildValue: 50,
  rangeValue: 50,
  list: [0, 0, 0, 0, 0], //Tracking how many items has been added for each wildValue. Used for deciding the column span
  ticks: [0, 25, 50, 75, 100],
  range: null,
  indicator: null,
  outfitInputRange: {
    [":style"]() {
      return { width: `${this.wildValue || "0"}%` };
    },
  },

  init() {
    this.setIsMobile();
    this.initSlider();
    const range = document.getElementById("outfitInput");
    const indicator = document.getElementById("outfitIndicator");
    this.range = range;
    this.indicator = indicator;

    this.setIndicatorValue();

    range.addEventListener("input", this.setIndicatorValue.bind(this));
  },

  getClosest(arr, val) {
    return arr.reduce(function (prev, curr) {
      return Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev;
    });
  },

  setIsMobile() {
    this.isMobile = window.innerWidth < 1024 ? true : false;
  },

  setIndicatorValue(event = null) {
    const eventTargetValue = event?.target?.value;
    const value = eventTargetValue || this.wildValue;
    this.rangeValue = value;

    this.range.style.background =
      "linear-gradient(to right, #000 0%, #000 " +
      value +
      "%, #D9D9D9 " +
      value +
      "%, #D9D9D9 100%)";

    const newValue = Number(
        ((value - this.range.min) * 100) / (this.range.max - this.range.min)
      ),
      newPosition = 10 - newValue * 0.2;
    this.indicator.innerHTML = `<span data-first="[" data-last="]">${this.getClosest(
      this.ticks,
      value
    )}%</span>`;
    this.indicator.style.left = `calc(${newValue}% + (${newPosition}px))`;
  },

  setWildValue(value) {
    this.wildValue = this.getClosest(this.ticks, value);
    this.setIndicatorValue();
  },

  setColumnClass(wildValue, index) {
    // Determine the column span for each product
    switch (true) {
      case this.list[wildValue / 25] === 0: // We have no items in wildValue X%. Set the first item to span 12 columns on mobile and 7 on desktop
        this.$refs["productMobile-" + index] &&
          ((this.$refs["productMobile-" + index].style.gridColumn = "span 9"),
          (this.$refs["productMobile-" + index].style.paddingLeft = "0.5rem"));
        this.$refs["product-" + index] &&
          (this.$refs["product-" + index].style.gridColumn = "span 7");
        this.list[wildValue / 25] += 1;
        break;
      case this.list[wildValue / 25] === 1: // We already have one item with wildValue X%. Set the secont item to span 9 columns
        this.$refs["productMobile-" + index] &&
          (this.$refs["productMobile-" + index].style.gridColumn = "span 7");
        this.$refs["product-" + index] &&
          (this.$refs["product-" + index].style.gridColumn = "span 9");
        this.list[wildValue / 25] += 1;
        break;
      case this.list[wildValue / 25] === 2:
        this.$refs["productMobile-" + index] &&
          ((this.$refs["productMobile-" + index].style.gridColumn = "span 8"),
          (this.$refs["productMobile-" + index].style.paddingRight = "0.5rem"));
        this.$refs["product-" + index] &&
          (this.$refs["product-" + index].style.gridColumn = "span 8");
        this.list[wildValue / 25] += 1;
        break;
      default: // We already have three items with wildValue X%. Hide the rest.
        this.$refs["product-" + index] &&
          this.$refs["product-" + index].classList.add("outfitHidden");
        this.$refs["productMobile-" + index] &&
          this.$refs["productMobile-" + index].classList.add("outfitHidden");
    }
  },

  initSlider() {
    this.swiper = new Swiper(this.$refs.slider, {
      cssMode: true,
      preloadImages: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      slidesOffsetBefore: 8,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      modules: [Scrollbar],
    });
  },
});
